var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "none",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.167 9.66699C20.1596 9.66717 21.5115 12.0939 21.8174 13.2832L21.833 13.3447V14.333H20.833V13.4785C20.5575 12.4929 19.4644 10.6672 17.167 10.667C14.8693 10.667 13.7755 12.4929 13.5 13.4785V15.5H18.833V16.5H12.5C11.6716 16.5 11 17.1716 11 18V24C11 24.8284 11.6716 25.5 12.5 25.5H22.667C23.4953 25.4998 24.167 24.8283 24.167 24V21H25.167V24C25.167 25.3806 24.0476 26.4998 22.667 26.5H12.5C11.1193 26.5 10 25.3807 10 24V18C10 16.6193 11.1193 15.5 12.5 15.5V13.3447L12.5156 13.2832C12.8214 12.0939 14.1741 9.66699 17.167 9.66699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 16L17.8427 22.3372C17.6736 22.5161 17.3889 22.5161 17.2198 22.3372L14.6666 19.6364",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLock);
export default __webpack_public_path__ + "static/media/UnLock.f28674a33fa15b10726b784cf09066ff.svg";
export { ForwardRef as ReactComponent };